import React from "react";

export const rewards = [
  { name: "Turning chaos into order", src: "/puzzle.png" },
  { name: "The world feels more aware", src: "/earth.png" },
  { name: "More clarity, because of you", src: "/sunny.png" },
  { name: "More present than before.", src: "/present.png" },
];

{
  /*name: "Clearing the mind", src: "/sunny.png"},*/
}
